<template>
  <div class="AppFileUploadFilder">
    <div class="AppFileUploadFilder__icon">
      <v-progress-circular v-if="filderStatus === uploadStatus.PENDING || filderStatus === uploadStatus.IN_PROGRESS"
                           :model-value="filderProgress"
                           color="surface-inverted"
                           size="28"
                           width="3"
      />
      <app-material-icon v-else-if="filderStatus === uploadStatus.SUCCESS"
                         name="check_circle"
                         size="lg"
                         color="success"
      />
      <AppButton v-else-if="filderStatus === uploadStatus.ERROR && !filderError"
                 icon
                 size="small"
                 @click="redoFilder"
      >
        <app-material-icon name="redo" color="error"/>
      </AppButton>
    </div>
    <div class="AppFileUploadFilder__content">
      <AppTooltip>
        <template #activator="{props}">
          <div class="AppFileUploadFilder__name" v-bind="props">
            <slot name="filderName"></slot>
            <span class="AppFileUploadFilder__fileName">{{ filderName }}</span>
          </div>
        </template>
        <span>{{ filderName }}</span>
      </AppTooltip>
      <span v-if="filderStatus === uploadStatus.PENDING" class="AppFileUploadFilder__statusLabel">
        {{ $t('common.app-file-upload.AppFileUploadFilder.pending') }}
      </span>
      <span v-else-if="filderStatus === uploadStatus.IN_PROGRESS" class="AppFileUploadFilder__statusLabel">
        {{ $t(filderProgress >= 100
          ? 'common.app-file-upload.AppFileUploadFilder.processing'
          : 'common.app-file-upload.AppFileUploadFilder.uploading') }}
      </span>
      <span v-else-if="filderSize" class="AppFileUploadFilder__fileSize">{{ filderSize }}</span>
    </div>
    <div class="AppFileUploadFilder__action">
      <AppTooltip v-if="filderStatus === uploadStatus.PENDING || filderStatus === uploadStatus.IN_PROGRESS">
        <template #activator="{props}">
          <AppButton icon
                     size="small"
                     variant="text"
                     v-bind="props"
                     @click="onCancelClick"
          >
            <app-material-icon name="close" size="sm"/>
          </AppButton>
        </template>
        <span>{{ $t('common.cancel') }}</span>
      </AppTooltip>
      <slot v-if="filderStatus === uploadStatus.SUCCESS" name="successAction"/>
      <div v-if="filderStatus === uploadStatus.CANCELED"
           class="AppFileUploadFilder__canceledLabel"
      >
        {{ $t('common.app-file-upload.AppFileUploadFilder.canceledImport') }}
      </div>
      <div v-if="filderStatus === uploadStatus.ERROR && filderError">
        {{ filderError }}
      </div>
    </div>
  </div>
</template>

<script>
import AppTooltip from '@/common/AppTooltip.vue'
import AppButton from '@/common/buttons/AppButton.vue'

import { uploadStatus } from './uploadStatus'

export default {
  name: 'AppFileUploadFilder',
  components: { AppButton, AppTooltip },
  props: {
    filder: {
      type: Object,
      required: true,
    },
    filderName: {
      type: String,
      required: true,
    },
    filderProgress: {
      type: Number,
      required: true,
    },
    filderStatus: {
      type: String,
      required: true,
    },
    filderSize: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      uploadStatus,
    }
  },
  computed: {
    filderError () {
      if (this.filder.error) {
        if (this.filder.error === 'ERR_WRONG_FILE_TYPE' || this.filder.error === 'ERR_FILE_TOO_LARGE') {
          return this.$t(`common.app-file-upload.AppFileUploadFilder.error.${this.filder.error}`)
        }
      }
      return null
    },
  },
  methods: {
    onCancelClick () {
      this.filderStatus === this.uploadStatus.PENDING ? this.cancelPendingFilder() : this.cancelInProgressFilder()
    },
    cancelPendingFilder () {
      this.$emit('cancelPendingFilder')
    },
    cancelInProgressFilder () {
      this.$emit('cancelInProgressFilder')
    },
    redoFilder () {
      this.$emit('redoFilder')
    },
  },
}
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";

.AppFileUploadFilder {
  display: flex;
  align-items: center;
  column-gap: 8px;
  padding: 4px 0;

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 28px;
    height: 28px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1 0 0;
    min-width: 0;
  }

  &__name {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  &__fileName {
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: rgb(var(--v-theme-text-primary));
  }

  &__fileSize,
  &__statusLabel {
    font-size: 12px;
    line-height: 16px;
    color: rgb(var(--v-theme-text-placeholder));
  }

  &__canceledLabel {
    font-size: 12px;
    font-weight: 600;
    color: rgb(var(--v-theme-text-placeholder));
  }

  &__action {
    flex-shrink: 0;
  }
}
</style>
